(function ($) {
	class Block_Audio extends BD_Block {
		constructor() {
			super();

			this.type = "audio";
			this.templateID = "audio-template";

			this.elms = {
				playBtn: ".js-play",
				pauseBtn: ".js-pause",
				questionCard: ".questionCard",
				answer: ".js-answer",
				submit: ".js-submit",
				skip: ".js-skip",
				backWrapper: ".questionCard__back",
				back: ".js-back",
			};

			this._events = this.getEvents();

			/* custom attributes */
			this.audio = false;
		}

		getEvents() {
			const elms = this.elms;
			return [
				{
					event: "click",
					selector: elms.playBtn,
					handler: this.onPlayAudio,
				},
				{
					event: "click",
					selector: elms.pauseBtn,
					handler: this.onPauseAudio,
				},
				{
					event: "click",
					selector: elms.skip,
					handler: this.onPauseAudio,
				},
				{
					event: "click",
					selector: elms.skip,
					handler: this.onSkip,
				},
				{
					event: "click",
					selector: elms.submit,
					handler: this.submit,
				},
				{
					event: "click",
					selector: elms.back,
					handler: this.back,
				},
			];
		}

		beforeinit() {
			this.render();
			this.registerAudio();
			this.setGameState();
			this.setQuestion();
			this.setTimer();
		}

		render() {
			const htmlTemplate = $("#" + this.templateID).html();
			let template = Handlebars.compile(htmlTemplate);

			const html = template(this._data);
			$("#templateWrapper").html(html);
		}

		registerAudio() {
			const _this = this;

			const audioFromVariable = BD_Variable.getAudioFromVariable(this._data)
			const audio = audioFromVariable || this._data.audio

			if (audio) {
				this.audio = new Audio(audio);

				this.audio.addEventListener("ended", () => this.onEnded(_this));

				this.onPlayAudio();
			}
		}

		onEnded(ctx) {
			const $questionCard = $(ctx.elms.questionCard);
			if (!ctx._data.has_question) {
				BD_GAME_LOGIC.goToDefaultNextBlock();
				return false;
			}

			this.timer.start();
			$questionCard.removeClass("audioPlaying").addClass("is-opened");
			ctx.question.showSubmitBtn(ctx);
		}

		setGameState() {
			const showBackBtn = () => {
				if(BD_SequenceHistory.data) {
					$(this.elms.backWrapper).addClass('is-active')
				}
			}

			showBackBtn()
		}

		setQuestion() {
			this.question = BD_Question.create(this._data.question)
			this._events = [...this._events, ...this.question.getEvents()];
		}

		setTimer() {
			this.timer = new BD_Timer(this._data, this.question);
		}

		/* ========= ELEMENT FUNCTION HANDLER ===============*/
		onPlayAudio(e, $el) {
			if (e) e.preventDefault();

			const $questionCard = $(this.elms.questionCard);

			if (!this.audio) {
				$questionCard.addClass("is-opened");
				this.timer.start();
				return true;
			}

			if (this.audio.paused) {
				var startPlayPromise = this.audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
							$questionCard.addClass("audioPlaying");
						})
						.catch((error) => {
							console.log("Unable to start auto play", error);

							if (error.name === "NotAllowedError") {
								//Show play button here
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		}

		onPauseAudio(e) {
			if (e) e.preventDefault();

			if (!this.audio) return true;

			const $questionCard = $(this.elms.questionCard);

			if (!this.audio.paused) {
				try {
					this.audio.pause();
					$questionCard.removeClass("audioPlaying");
				} catch (error) { }

				return;
			}
		}

		onSkip(e) {
			const _this = this;
			this.onEnded(_this)
		}

		back(e) {
			const seqHistory = BD_SequenceHistory.data;
			const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID())
			const history = seqHistory[currentBlockID]
			if(!history) return

			BD_GAME_LOGIC.goBack(history.prev)
		}

		submit(e, $el) {
			this.question.submitAnswer($el, this);
		}

		afterDestroy() {
			this.timer.stop();
			if (this.audio && !this.audio.paused) {
				try {
					this.audio.pause();
					this.audio = false;
				} catch (error) { }
				return;
			}
		}
	}

	return new Block_Audio();
})(jQuery);
